import { useMedia } from "use-media"

export const useResponsive = () => {
    const isMobile = useMedia({ maxWidth: 1024 })
    const isDesktop = useMedia({ minWidth: 1025 })

    return { isMobile, isDesktop }
}